// extracted by mini-css-extract-plugin
module.exports = {"bottomMenu":"BottomMenu_bottomMenu__1HryU","minified":"BottomMenu_minified__1hXCf","item":"BottomMenu_item__3dmh_"};